import React from 'react';
import { GridCellParams } from '@mui/x-data-grid';
import { CheckCircle as CheckCircleIcon } from '@mui/icons-material';

/** Shows a flag only when it is on; an off flag is left blank on purpose. */
export const BooleanFlagCell = ({ value }: GridCellParams) =>
    value ? <CheckCircleIcon fontSize="small" sx={{ color: 'success.main' }} /> : null;
